
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateCartItem } from "../actions/cartActions";
import { useSelector } from "react-redux";
import { listSizes } from "../actions/sizeActions";
import { Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";
import BraceletSizeSelector from "./BraceletSizeSelector";
import RingSizeSelector from "./RingSizeSelector";
import AnkletSizeSelector from "./AnkletSizeSelector";
import PetEngraving from '../components/petEngraving';
import ProductSet2 from "../components/ProductSet2";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  Box,
  AccordionPanel,
  AccordionIcon,
  Icon,

} from "@chakra-ui/react";
import { FaRegEdit } from "react-icons/fa";

const EngravingInput = ({ item, setIsAccordionOpen }) => {
  // console.log("items", item);
  const [productSet, setProductSet] = useState(
    item.products.map((product) => product._id) || []
  );
  const [allowRingSize, setAllowRingSize] = useState(
    item.products.some((product) =>
      product.sku.toUpperCase().includes("SAIR")
    ) || false
  );
  const [selectedItems, setSelectedItems] = useState(
    item.products.map((product) => ({
      itemPrice: product.price,
      sku: product.sku,
    })) || []
  );
  const [selectedItemBasePrice, setSelectedItemBasePrice] = useState(
    item.products.map((product) => ({
      itemBasePrice: product.basePrice,
      sku: product.sku,
    })) || []
  );

  const [allowAnkletType, setAllowAnkletType] = useState(
    item.products.some((product) =>
      product.sku.toUpperCase().includes("SAIA")
    ) || false
  );
  const [price, setPrice] = useState(0);
  const [basePrice, setBasePrice] = useState(0);
  const [isPair, setIsPair] = useState(item.isPair || false);
  const [allowBraceletSize, setAllowBraceletSize] = useState(
    item.products.some((product) =>
      product.sku.toUpperCase().includes("SAIB")
    ) || false
  );



  const [selectedBraceletSizeMen, setSelectedBraceletSizeMen] = useState(
    item.braceletsSizeMen || ""
  );
  const [selectedBraceletSizeWomen, setSelectedBraceletSizeWomen] = useState(
    item.braceletsSizeWomen || ""
  );

  const [selectedAnkletSize, setSelectedAnkletSize] = useState(
    item.ankletsSize || ""
  );
  // console.log("Size :- ",selectedBraceletSizeWomen)
  let [isBraceletSize, setIsBraceletSize] = useState(false);
  let [isAnkletSize, setIsAnkletSize] = useState(false);

  const dispatch = useDispatch();

  const [addEngrave, setAddEngrave] = useState(
    item.engraveMen !== "" || item.engraveWomen !== "" ? true : false
  );

  const [isConsentChecked, setIsConsentChecked] = useState(
    item.engraveMen !== "" || item.engraveWomen !== "" ? true : false
  );

  const [engraveMenText, setEngraveMenText] = useState(item.engraveMen || "");
  // const [backEng, setbackEng] = useState(item.backEng || "");
  // const [engImage, setEngImage] = useState(item.engImage || "");
  const [engraveWomenText, setEngraveWomenText] = useState(
    item.engraveWomen || ""
  );

  const [giftWrap, setGiftWrap] = useState(item.giftWrap || false);
  const [message, setMessage] = useState(item.message || "");

  const [sizeMen, setSizeMen] = useState(item.sizeMen);
  const [sizeWomen, setSizeWomen] = useState(item.sizeWomen);
  let [isOpen, setIsOpen] = useState(false);
  const [finalAmount, setfinalAmount] = useState(0);
  const [itemPer, setItemPer] = useState(item?.setItemsPer || 2);

  const sizeList = useSelector((state) => state.sizeList);
  const { loading: loadingSize, error: errorSize, sizes } = sizeList;


  const [frontPetTexts, setFrontPetTexts] = useState([]);
  const [petTypesSelected, setPetTypesSelected] = useState([]);
  const [backPetTexts, setBackPetTexts] = useState([]);
  const [breedAge, setBreedAge] = useState([]);
  const [breedSize, setBreedSize] = useState([]);

  const handlePetFrontEngChange = (text, index) => {
    const updated = [...frontPetTexts];
    updated[index] = text;
    setFrontPetTexts(updated);
  };

  const handlePetTypeChange = (pet, index) => {
    const updated = [...petTypesSelected];
    updated[index] = pet;
    setPetTypesSelected(updated);
  };

  const handlePetBackEngChange = (text, index) => {
    const updated = [...backPetTexts];
    updated[index] = text;
    setBackPetTexts(updated);
  };

  const handleBreedAgeChange = (text, index) => {
    const updated = [...breedAge];
    updated[index] = text;
    setBreedAge(updated);
  };

  const handleBreedSizeChange = (text, index) => {
    const updated = [...breedSize];
    updated[index] = text;
    setBreedSize(updated);
  };

  useEffect(() => {
    if (
      item?.product &&
      item?.product.productCollections?.some(cat => cat.name === "Pet Collection") &&
      item?.product?.canEngrave && item?.product?.canBackEng
    ) {
      const q = item?.qty || 1;

      setFrontPetTexts(prev => {
        const updated = [...item?.petFrontEng, ...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setPetTypesSelected(prev => {
        const updated = [...item?.petEngImage, ...prev];
        while (updated.length < q) updated.push(null);
        return updated.slice(0, q);
      });

      setBackPetTexts(prev => {
        const updated = [...item?.petBackEng, ...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setBreedAge(prev => {
        const updated = [...item?.breedAge, ...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setBreedSize(prev => {
        const updated = [...item?.breedSize, ...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });
    }
  }, [item?.qty]);


  useEffect(() => {
    dispatch(listSizes());
  }, [dispatch]);


  const totalPrice =
    productSet.length > 0
      ? selectedItems.reduce((sum, item) => {
        const price = item.sku.includes("SAIA")
          ? isPair
            ? item.itemPrice * 2
            : item.itemPrice
          : item.itemPrice;
        return sum + price;
      }, 0)
      : item.product?.price;

  const totalBasePrice =
    productSet.length > 0
      ? selectedItemBasePrice.reduce((sum, item) => {
        const basePrice = item.sku.includes("SAIA")
          ? isPair
            ? item.itemBasePrice * 2
            : item.itemBasePrice
          : item.itemBasePrice;
        return sum + basePrice;
      }, 0)
      : item.product?.basePrice;

  useEffect(() => {
    let overallDiscount = Number(
      (
        ((item.product?.basePrice - item.product?.price) /
          item.product?.basePrice) *
        100
      )?.toFixed(0)
    );

    if (selectedItems.length < 2) {
      // console.log(totalPrice);
      setfinalAmount(totalPrice);
    } else {
      // console.log("total price", totalBasePrice);
      let extraDiscount = (selectedItemBasePrice.length - 1) * itemPer;
      let finalDiscount = overallDiscount + extraDiscount;
      let discountedPrice = Number(
        (totalBasePrice - (totalBasePrice * finalDiscount) / 100).toFixed(0)
      );

      setfinalAmount(discountedPrice);
    }
  }, [selectedItemBasePrice, isPair]);

  const handleEngravingInputChange = (e, gender) => {
    const value = e.target.value;
    const lettersAndSpaces = /^[A-Za-z ]*$/; // Regex to allow only letters and spaces
    if (lettersAndSpaces.test(value)) {
      if (gender === "male") {
        setEngraveMenText(value); // Update local state for men
      } else {
        setEngraveWomenText(value); // Update local state for women
      }
    }
  };

  const notify = (link, content, type) =>
    type(<RouterLink to={link}>{content}</RouterLink>);

  const handleUpdateClick = () => {

    const updateCart = () => {
      dispatch(
        updateCartItem(
          item?.product?._id,
          item?.variant,
          item?.qty,
          sizeMen,
          sizeWomen,
          giftWrap,
          message,
          engraveMenText, // Use the local state for men's engraving
          engraveWomenText,
          productSet,
          finalAmount,
          totalBasePrice,
          isPair,
          selectedBraceletSizeMen,
          selectedBraceletSizeWomen,
          selectedAnkletSize,
          frontPetTexts,
          backPetTexts,
          petTypesSelected,
          breedAge,
          breedSize,
        )
      );
      setIsAccordionOpen(false);
    };

    const categories = item?.product.categories?.map(c => c.name?.toLowerCase()) || [];
    const subcategories = item?.product.subcategories?.map(s => s.name?.toLowerCase()) || [];

    const isListString = (list) => {
      return Array.isArray(list) && list.every(item => typeof item === 'string');
    };

    const isRings = categories.includes("rings");
    const isBracelets = categories.includes("bracelets");
    const isAnklets = categories.includes("anklets");
    const isCoupleRing = subcategories.includes("couple rings");
    const isCoupleBracelets = subcategories.includes("for couples");
    const isSets = categories.includes("jewellery sets");
    const isMale = item?.product.gender?.toLowerCase() === "male";

    const details = item?.product;

    if (isSets && productSet.length > 0 && productSet.length < 2) {
      notify("#", "Please Select Min 2 Items in Customized Set", toast.error);
      return;
    }

    if (isRings && isCoupleRing && (sizeMen === '0' || sizeWomen === '0')) {
      notify("#", "Select Both Ring Size", toast.error);
      return;
    }

    if (isRings && isMale && sizeMen === '0') {
      notify("#", "Select Ring Size", toast.error);
      return;
    }

    if ((isRings ||
      (isSets && productSet.length === 0) ||
      (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIR")))
    ) && !isMale && sizeWomen === "0") {
      notify("#", "Select Ring Size", toast.error);
      return;
    }

    if (
      (isAnklets ||
        (isSets && productSet.length === 0 &&
          !isListString(details.products) &&
          details.products?.some(e => e.sku?.includes("SAIA"))) ||
        (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIA")))
      ) && selectedAnkletSize === ""
    ) {
      notify("#", "Select Anklet Size", toast.error);
      return;
    }

    if (isBracelets && isCoupleBracelets && (selectedBraceletSizeWomen === "" || selectedBraceletSizeMen === "")) {
      notify("#", "Select Both Bracelets Size", toast.error);
      return false;
    }

    if (isBracelets && isMale && selectedBraceletSizeMen === "") {
      notify("#", "Select Bracelets Size", toast.error);
      return false;
    }

    if (
      (isBracelets ||
        (isSets && productSet.length === 0 &&
          !isListString(details.products) &&
          details.products?.some(e => e.sku?.includes("SAIB"))) ||
        (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIB")))
      ) && !isMale && selectedBraceletSizeWomen === ""
    ) {
      notify("#", "Select Bracelets Size", toast.error);
      return false;
    }

    if (details.canImgEng && details.canBackEng) {
      if (petTypesSelected.includes(null) || petTypesSelected.length === 0 || petTypesSelected.includes('')) {
        notify("#", "Please Select Breed", toast.error);
        return;
      }

      if (breedSize.includes('')) {
        notify("#", "Please Select Size", toast.error);
        return;
      }

      if (breedAge.includes('')) {
        notify("#", "Please Select Your Pet Age", toast.error);
        return;
      }

      if (frontPetTexts.includes('')) {
        notify("#", "Enter Front Engraving Characters", toast.error);
        return;
      }

      if (backPetTexts.includes('')) {
        notify("#", "Enter Back Engraving Characters", toast.error);
        return;
      }
    }

    // All validations passed — add to cart
    updateCart();

  };

  function closeModal() {
    setIsOpen(false);
  }

  function closeBraceletModal() {
    setIsBraceletSize(false);
  }

  function closeAnkletModal() {
    setIsAnkletSize(false);
  }

  useEffect(() => {
    if (
      item &&
      item.product.products &&
      productSet.length > 0 &&
      item.product.products.length > 0 &&
      productSet.length === item.product.products.length
    ) {
      setSizeMen(0);
      setSizeWomen(0);
    }

    if (item) {
      const price = item.product?.categories?.some(
        (category) => category.name === "ANKLETS"
      )
        ? isPair
          ? item.product.price * 2
          : item.product.price
        : item.product?.products?.some((item) => item.sku.includes("SAIA"))
          ? isPair
            ? item.product.price +
            item.product.products.find((item) => item.sku.includes("SAIA"))
              ?.price
            : item.product.price
          : item.product.price;

      const basePrice = item.product?.categories?.some(
        (category) => category.name === "ANKLETS"
      )
        ? isPair
          ? item.product.basePrice * 2
          : item.product.basePrice
        : item.product?.products?.some((item) => item.sku.includes("SAIA"))
          ? isPair
            ? item.product.basePrice +
            item.product.products.find((item) => item.sku.includes("SAIA"))
              ?.basePrice
            : item.product.basePrice
          : item.product.basePrice;

      setPrice(price);
      setBasePrice(basePrice);
    }
  }, [productSet, item]);

  // console.log("prodeuct set",productSet?.length);
  console.log("items", item);


  return (
    <div className="flex flex-col gap-3">

      {/* Rings */}
      {allowRingSize ||
        (item?.product.products?.some((i) =>
          i.sku.toUpperCase().includes("SAIR")
        ) &&
          productSet.length === 0) ||
        item?.product?.categories?.some(
          (cat) => cat.name.toLowerCase() === "rings"
        ) ? <RingSizeSelector
        loadingSize={loadingSize}
        errorSize={errorSize}
        sizes={sizes}
        selectedProduct={item?.product}
        selectedSizeMen={sizeMen}
        setSelectedSizeMen={setSizeMen}
        selectedSizeWomen={sizeWomen}
        setSelectedSizeWomen={setSizeWomen}

      /> : null}

      {/* For Anklets */}
      {allowAnkletType ||
        (item?.product.products?.some((item) =>
          item.sku.toUpperCase().includes("SAIA")
        ) &&
          productSet.length === 0) ||
        item?.product?.categories?.some(
          (cat) => cat.name === "ANKLETS"
        ) ? (
        <AnkletSizeSelector
          value={selectedAnkletSize}
          onChange={(e) => setSelectedAnkletSize(e.target.value)}
          isPair={isPair}
          setIsPair={setIsPair}
        />

      ) : null}

      {/* Bracelet Size */}

      {allowBraceletSize ||
        (item?.product.products?.some((item) =>
          item.sku.toUpperCase().includes("SAIB")
        ) &&
          productSet.length === 0) ||
        item?.product?.categories?.some(
          (cat) => cat.name === "BRACELETS"
        )

        ? <BraceletSizeSelector
          selectedProduct={item?.product}
          selectedBraceletSizeMen={selectedBraceletSizeMen}
          setSelectedBraceletSizeMen={setSelectedBraceletSizeMen}
          selectedBraceletSizeWomen={selectedBraceletSizeWomen}
          setSelectedBraceletSizeWomen={
            setSelectedBraceletSizeWomen}
        />
        : null}

      {/* Jewellery Sets */}
      {item?.product?.categories?.some(
        (cat) => cat.name == "JEWELLERY SETS"
      ) ? (
        <ProductSet2
          product={item?.product}
          variantId={item?.variant}
          productSet={productSet}
          setProductSet={setProductSet}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          selectedItemBasePrice={selectedItemBasePrice}
          setSelectedItemBasePrice={setSelectedItemBasePrice}
          totalPrice={finalAmount}
          totalbasePrice={totalBasePrice}
          allowRingSize={allowRingSize}
          setAllowRingSize={setAllowRingSize}
          allowBraceletSize={allowBraceletSize}
          setAllowBraceletSize={setAllowBraceletSize}
          allowAnkletType={allowAnkletType}
          setAllowAnkletType={setAllowAnkletType}
          isPair={isPair}
          setIsPair={setIsPair}
        />
      ) : null}

      {item?.product?.categories?.some(
        (cat) =>
          cat.name === "Rings" || cat.name.toLowerCase() === "bracelets" || cat.name === "PENDANTS" || cat.name == "JEWELLERY SETS"
      ) &&
        (item?.product?.subcategories?.some(
          (cat) => cat.name === "Couple Rings"
        ) || item?.product?.subcategories?.some(
          (cat) => cat.name.toLowerCase() === "for couples"
        ) ? (
          <Accordion
            allowMultiple
            // onChange={() => handleAccordionToggle(!isAccordionOpen)}
            my="6"
          >
            <AccordionItem>
              <h2>
                <AccordionButton>
                  <FaRegEdit className="w-5 h-5" />
                  <Box as="span" flex="1" textAlign="left" className="pl-2">
                    Engraving
                    <div className="text-[12px]">(Charge Rs. 10 Per Character)</div>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <input
                  type="text"
                  maxLength="10" // Limits input to 10 characters
                  pattern="[A-Za-z]*" // Allows only letters and spaces
                  value={engraveMenText} // Controlled input
                  className="border px-2 py-1 rounded mb-1"
                  placeholder="Engraving For Men"
                  onChange={(e) => handleEngravingInputChange(e, "male")} // Handle engraving input
                />
                <p className="text-sm text-gray-500 mb-2">
                  Max 10 characters, letters only.
                </p>
                <input
                  type="text"
                  maxLength="10" // Limits input to 10 characters
                  pattern="[A-Za-z]*" // Allows only letters and spaces
                  value={engraveWomenText} // Controlled input
                  className="border px-2 py-1 rounded"
                  placeholder="Engraving for Women"
                  onChange={(e) => handleEngravingInputChange(e, "female")} // Handle engraving input
                />
                <p className="text-sm text-gray-500">
                  Max 10 characters, letters only.
                </p>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        ) : (
          <>
            {(allowRingSize || productSet.length === 0) && item?.product?.productCollections?.some(
              (cat) => cat.name !== "Pet Collection"

            ) ? (
              <div>
                <Accordion
                  allowMultiple
                  // onChange={() =>
                  //   handleAccordionToggle(!isAccordionOpen)
                  // }
                  my="6"
                >
                  <AccordionItem>
                    <h2>
                      <AccordionButton>
                        <FaRegEdit className="w-5 h-5" />
                        <Box as="span" flex="1" textAlign="left" className="pl-2">
                          Engraving
                          <div className="text-[12px]">(Charge Rs. 10 Per Character)</div>
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4}>
                      <input
                        type="text"
                        maxLength="10" // Limits input to 10 characters
                        pattern="[A-Za-z]*" // Allows only letters and spaces
                        value={
                          item?.product?.gender === "male"
                            ? engraveMenText
                            : engraveWomenText
                        } // Controlled input
                        className="border px-2 py-1 rounded"
                        placeholder="Engraving text"
                        onChange={(e) =>
                          handleEngravingInputChange(
                            e,
                            item?.product?.gender === "male" ? "male" : "female"
                          )
                        } // Handle engraving input
                      />
                      <p className="text-sm text-gray-500">
                        Max 10 characters, letters only.
                      </p>
                    </AccordionPanel>
                  </AccordionItem>
                </Accordion>
              </div>
            ) : item?.product?.productCollections?.some(cat => cat.name === "Pet Collection") &&
              item?.product?.canEngrave && !item?.product?.canBackEng ? (
              <div>
                <Accordion
                  allowMultiple
                  // onChange={() =>
                  //   handleAccordionToggle(!isAccordionOpen)
                  // }
                  my="6"
                >
                  <AccordionItem>
                    <h2>
                      <AccordionButton>
                        <FaRegEdit className="w-5 h-5" />
                        <Box as="span" flex="1" textAlign="left" className="pl-2">
                          Engraving
                          <div className="text-[12px]">(Charge Rs. 10 Per Character)</div>
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4}>
                      <input
                        type="text"
                        maxLength="10" // Limits input to 10 characters
                        pattern="[A-Za-z]*" // Allows only letters and spaces
                        value={
                          item?.product?.gender === "male"
                            ? engraveMenText
                            : engraveWomenText
                        } // Controlled input
                        className="border px-2 py-1 rounded"
                        placeholder="Engraving text"
                        onChange={(e) =>
                          handleEngravingInputChange(
                            e,
                            item?.product?.gender === "male" ? "male" : "female"
                          )
                        } // Handle engraving input
                      />
                      <p className="text-sm text-gray-500">
                        Max 10 characters, letters only.
                      </p>
                    </AccordionPanel>
                  </AccordionItem>
                </Accordion>
              </div>
            )
              :
              null}
          </>
        ))}

      {/* {
        (item?.product?.canEngrave && item?.product?.productCollections?.some(cat => cat.name !== "Pet Collection")) && (<>

          <div
            className={`${item?.product?.categories?.some(
              (cat) => cat.name === "Rings" || cat.name == "JEWELLERY SETS" || cat.name == "BRACELETS" || cat.name === "PENDANTS"
            )
              ? "flex"
              : "hidden"
              } items-center gap-1`}
          >
            <div className="font-medium">Engraving</div>
            <div className="text-[12px]">(Charge Rs. 10 Per Character)</div>
          </div>

          <div
            className={`${item?.product?.categories?.some(
              (cat) => cat.name === "Rings" || cat.name == "JEWELLERY SETS" || cat.name === "PENDANTS" || cat.name == "BRACELETS"
            )
              ? "flex"
              : "hidden"
              } flex-col gap-4 border border-black p-2`}
          >
        
            <button
              onClick={() => {
                setEngraveMenText("");
                setEngraveWomenText("");
                setAddEngrave(!addEngrave);
                setIsConsentChecked(false);
              }}
              className={`flex gap-4 px-2 py-1 rounded-md text-sm uppercase ${addEngrave ? "text-red-500" : "text-black"
                }`}
            >
              <BiMessageSquareEdit className="w-5 h-5" />
              <p>{addEngrave ? "Remove Engraving" : "Add Engraving"}</p>
            </button>
            {addEngrave && (
              <div className="flex gap-4">
                {item?.product?.subcategories?.some(
                  (subcat) => subcat?.name === "Couple Rings" || subcat.name === "FOR COUPLES"
                ) ? (
                  <div className="flex flex-col gap-4 w-full">
                    <div className="flex flex-col gap-2 border-b border-gray-300">
                      <label>Women</label>
                      <input
                        type="text"
                        maxLength="10" // Limits input to 10 characters
                        value={engraveMenText} // Controlled input using local state for men
                        className="px-2 py-1.5 rounded text-sm w-full border-none"
                        placeholder="Max 10 characters, letters only."
                        onChange={(e) => handleEngravingInputChange(e, "male")} // Handle local input change for men
                      />
                    </div>
                    <div className="flex flex-col gap-2 border-b border-gray-300">
                      <label>Men</label>
                      <input
                        type="text"
                        maxLength="10" // Limits input to 10 characters
                        value={engraveWomenText} // Controlled input using local state for women
                        className="px-2 py-1.5 rounded text-sm w-full border-none"
                        placeholder="Max 10 characters, letters only."
                        onChange={(e) => handleEngravingInputChange(e, "female")} // Handle local input change for women
                      />
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col gap-4 w-full">
                    <div className="flex flex-col gap-2 border-b border-gray-300">
                      <lable>Engraving</lable>
                      <input
                        type="text"
                        maxLength="10" // Limits input to 10 characters
                        value={
                          item?.product?.gender === "female"
                            ? engraveWomenText
                            : engraveMenText
                        } // Controlled input using local state for men
                        className="px-2 py-1.5 rounded text-sm w-full border-none"
                        placeholder="Engraving text"
                        onChange={(e) =>
                          handleEngravingInputChange(
                            e,
                            item?.product?.gender === "female" ? "female" : "male"
                          )
                        } // Handle local input change for men
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
            {addEngrave && (
              <div className="flex gap-1">
                <input
                  type="checkbox"
                  className="m-1"
                  checked={isConsentChecked}
                  onChange={(e) => setIsConsentChecked(e.target.checked)}
                />
                <p className="text-[12px]">
                  Please be aware that personalised products cannot be returned and
                  personalisation may affect the delivery time of your creation.
                  Please carefully read the{" "}
                  <a
                    href="../terms-and-conditions.html"
                    className="underline text-[#000080]"
                  >
                    Terms & Conditions
                  </a>{" "}
                  and{" "}
                  <a
                    href="../privacy-policy.html"
                    className="underline text-[#000080]"
                  >
                    Privacy Policy
                  </a>
                  .
                </p>
              </div>
            )}
          </div>

        </>)
      } */}

      {item?.product?.productCollections?.some(cat => cat.name === "Pet Collection") &&
        item?.product?.canEngrave && item?.product?.canBackEng &&
        [...Array(item?.qty || 1)].map((_, index) => (

          <PetEngraving
            key={index}
            index={index}
            product={item?.product}
            selectedPetType={petTypesSelected[index]}
            setSelectedPetType={(pet) => handlePetTypeChange(pet, index)}
            frontPetText={frontPetTexts[index]}
            handlePetFrontEngChange={(text) => handlePetFrontEngChange(text, index)}
            backPetText={backPetTexts[index]}
            handlePetBackEngChange={(text) => handlePetBackEngChange(text, index)}
            breedAge={breedAge[index]}
            handleBreedAgeChange={(text) => handleBreedAgeChange(text, index)}
            breedSize={breedSize[index]}
            handleBreedSizeChange={(text) => handleBreedSizeChange(text, index)}
          />
        ))}

      <div className="flex items-center gap-1">
        <div className="font-medium">Gift Wrap</div>
        <div className="text-[12px]">(Charge Rs. 50 Per Item Qty.)</div>
      </div>

      <div className="flex flex-col gap-4 border border-black p-2">
        <div className="flex justify-around">
          <div className="flex gap-6 items-center">
            <input
              type="radio"
              name="giftWrap"
              value="yes"
              radioGroup="giftWrap"
              checked={giftWrap === true}
              onChange={() => setGiftWrap(true)}
            />
            <label>Yes</label>
          </div>
          <div className="flex gap-6 items-center">
            <input
              type="radio"
              name="giftWrap"
              value="no"
              radioGroup="giftWrap"
              checked={giftWrap === false}
              onChange={() => setGiftWrap(false)}
            />
            <label>No</label>
          </div>
        </div>
        {giftWrap && (
          <textarea
            placeholder="Enter Message For Gift"
            value={message}
            className="p-3 bg-slate-100 rounded-md"
            onChange={(e) => setMessage(e.target.value)}
            maxLength={100}
          />
        )}
      </div>

      <div className="flex gap-4 ml-2">
        <button
          onClick={() => handleUpdateClick()}
          disabled={
            (addEngrave && isConsentChecked) ||
              (!addEngrave && !isConsentChecked)
              ? false
              : true
          }
          className={`bg-[#000080] text-white text-[14px] font-[600] px-2 py-1 rounded-md ${(addEngrave && isConsentChecked) ||
            (!addEngrave && !isConsentChecked)
            ? ""
            : "cursor-not-allowed"
            }`}
        >
          Update
        </button>
        <button
          onClick={() => setIsAccordionOpen(false)}
          className="bg-red-700 text-white text-[14px] font-[600] px-2 py-1 rounded-md"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default EngravingInput;
